module.exports = __webpack_public_path__ + "static/media/herb01-small.41e86f85.jpeg";